import React from 'react'
import { ColumnStartOrder, ColumnWarnings, ColumnNoc, ColumnName, ColumnEventUnitEntries, ColumnExpander } from "components/common/TableColumns"

export function TableColumns() {

    return (
        [
            ColumnStartOrder({ label: 'HeaderLane' }),
            ColumnNoc({}),
            ColumnName({label: 'HeaderTeam'}),
            ColumnWarnings({}),
            ColumnEventUnitEntries({ code: 'NR', label: 'HeaderNationalRecordH' }),
            ColumnEventUnitEntries({ code: 'SB', label: 'HeaderSeasonBestR' }),
            ColumnExpander({})
        ]

    )
}

export default TableColumns


